// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://bootstrap.knx-group.net/css/bootstrap.css);"]);
// Module
exports.push([module.id, ".app-table .img-product{width:100px;height:100px}.app-table .img-product img{width:100%;height:100%;-o-object-fit:contain;object-fit:contain}.app-table td{vertical-align:middle!important}.app-table tr.clickable-row{cursor:pointer}", ""]);
// Exports
module.exports = exports;
